export const getQuestionAnsweringInitialState = () => ({
    liked: false,
    disliked: false,
    expanded: false,
    feedbackModalOpen: false,
    relatedQuestions: [],
});
